import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Globe } from "lucide-react";
import { languages } from "./useApi";

export function LanguageSettings({ currentLang, onLanguageChange, t }) {
  return (
    <Card className="bento-card" data-testid="language-settings-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><Globe className="w-5 h-5" />{t("settings.language")}</CardTitle>
        <CardDescription>{t("settings.languageDesc")}</CardDescription>
      </CardHeader>
      <CardContent>
        <Select value={currentLang} onValueChange={onLanguageChange}>
          <SelectTrigger className="w-full" data-testid="language-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {languages.map(function(lang) {
              return <SelectItem key={lang.code} value={lang.code}><span className="mr-2">{lang.flag}</span>{lang.name}</SelectItem>;
            })}
          </SelectContent>
        </Select>
      </CardContent>
    </Card>
  );
}
